import * as React from 'react';
import * as moment from 'moment';

import { IEvent } from '../../custom/classes/event';
import { ICalendarState, IMonth, CalendarViewMode, CalendarDeviceMode } from '../../classes/calendar';
import { ICalendarAppText } from '../../custom/classes/calendar-text';

import { connect } from 'react-redux';

import ListContainerView from 'list-container.view';
import { ICalendarAppState } from '../../redux-state';

interface IListContainerExternalProps {

}

interface StateToProps {
    currentMoment: moment.Moment;
    calendarViewMode: CalendarViewMode;
    calendarDeviceMode: CalendarDeviceMode;
    eventCount: number;
    text: ICalendarAppText;
}

export type ListContainerProps = IListContainerExternalProps & StateToProps;

export const ListContainerBase: React.StatelessComponent<ListContainerProps> = props => {
        return (
            <ListContainerView {...props} />
        )
}

function mapStateToProps(state: ICalendarAppState, ownProps: IListContainerExternalProps): StateToProps {
    return {
        currentMoment: state.calendar.currentDate,
        calendarViewMode: state.calendarSettings.calendarViewMode,
        calendarDeviceMode: state.calendarSettings.calendarDeviceMode,
        eventCount: ([] as IEvent[]).concat(...state.calendar.events.map(month => ([] as IEvent[]).concat(...month.events.allDays.map(day => day.events)))).length,
        text: state.calendarText
    }
}

export default connect(mapStateToProps)(ListContainerBase);